import { cnl } from "csi/typings";
import { Button, GridRow, ModalDialog } from "designSystem/index";
import { ButtonEnum } from "designSystem/types/button-types";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { useSnapshotTemplateStore } from "../SnapshotTemplateStore";
import { FOOTER_BUTTONS, HIDE_OVERFLOW } from "../snapshotUtils";
import TemplateForm from "../templateForm/TemplateForm";
import SnapshotTemplateDialogStore, { SnapshotTemplateDialogStoreContext } from "./SnapshotTemplateDialogStore";

interface SnapshotTemplateDialogProps {
	/** Dialog store coming from the controller */
	store?: SnapshotTemplateDialogStore;
	
	/** template id to edit */
	selectedTemplate: cnl;
}

const SaveAndCancel: FunctionComponent = observer(() => {
	const { 
		saveTemplate,
		dialogStore: {
			canSaveStyleSnapshotTemplate,
			onCancel,
		}, 
	} = useSnapshotTemplateStore();

	return (
		<GridRow
			justifyContent="flex-end"
			spacing={2}
			sx={FOOTER_BUTTONS}
		>
			<Button
				design="primary"
				disabled={!canSaveStyleSnapshotTemplate}
				onClick={saveTemplate}
				res={ButtonEnum.BUTTON_SAVE}
			/>
			<Button
				design="link"
				fullWidth
				onClick={onCancel}
				res={ButtonEnum.BUTTON_CANCEL}
			/>
		</GridRow>
	);
});

const EditSnapshotTemplateDialog: FunctionComponent<SnapshotTemplateDialogProps> = observer((props) => {
	const { store, selectedTemplate } = props;
	const { onCancel, setImageOptions, setRendererOptions, setTemplateOptions, templateId } = store;

	return (
		<SnapshotTemplateDialogStoreContext.Provider value={store}>
			<ModalDialog
				maxWidth="sm"
				onClose={onCancel}
				open
				showClose
				showDividers
				sx={HIDE_OVERFLOW}
				titleRes="EditSnapshotTemplate"
				width="100%"
			>
				{{
					main: (
						<TemplateForm
							actions={<SaveAndCancel />} 
							id={templateId}
							selectedTemplate={selectedTemplate}
							setImageOptionsCallback={setImageOptions}
							setRendererOptionsCallback={setRendererOptions}
							setTemplateOptionsCallback={setTemplateOptions}
						/>
					),
				}}
			</ModalDialog>
		</SnapshotTemplateDialogStoreContext.Provider>
	);
});

export default EditSnapshotTemplateDialog;